import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=2e4a5574"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports